import React, { useEffect, useMemo, useState } from 'react';
import './RemitoPrintInline.css';
import logo from './../Logos/Priballl.png';

const CUIT_EMISOR = '20-33602790-0';
const INGRESOS_BRUTOS = '280-404387';
const FECHA_INICIO_ACTIVIDADES = '01/11/2012';

const formatNumber = (number) => {
  if (typeof number !== 'number' || isNaN(number)) return '0,00';
  return number
    .toFixed(2)
    .replace('.', ',')
    .replace(/\B(?=(\d{3})+(?!\d))/g, '.');
};

const normalizeDate = (date) => {
  if (!date) return 'N/A';
  try {
    const d = typeof date?.toDate === 'function' ? date.toDate() : new Date(date);
    return d.toLocaleString('es-AR');
  } catch (e) {
    return 'N/A';
  }
};

const RemitoPrintInline = ({ saleInfo, onClose }) => {
  const [transportista, setTransportista] = useState(saleInfo?.transportista || '');
  // Descripción alternativa a la tabla de productos
  const [useDescription, setUseDescription] = useState(false);
  const [descriptionText, setDescriptionText] = useState('');
  const [observaciones, setObservaciones] = useState(saleInfo?.observaciones || '');

  useEffect(() => {
    return () => {
      document.body.classList.remove('printing-remito-inline');
    };
  }, []);

  const totalWithDiscount = useMemo(() => {
    const products = saleInfo?.products || [];
    const total = products.reduce((acc, p) => acc + (Number(p.price) || 0) * (Number(p.quantity) || 0), 0);
    if (Number(saleInfo?.discountAmount) > 0) return total - Number(saleInfo.discountAmount);
    const discount = Number(saleInfo?.discount) || 0;
    return total - (total * discount) / 100;
  }, [saleInfo]);

  const handlePrint = () => {
    const products = saleInfo?.products || [];

    const fmt = (n) => formatNumber(Number(n) || 0);

    const subtotal = Number(saleInfo?.subtotal) || products.reduce((a, p) => a + (Number(p.price) || 0) * (Number(p.quantity) || 0), 0);
    const hasDiscountAmount = Number(saleInfo?.discountAmount) > 0;
    const discountAmount = hasDiscountAmount ? Number(saleInfo.discountAmount) : 0;
    const total = Number(saleInfo?.totalPrice) || (hasDiscountAmount ? subtotal - discountAmount : totalWithDiscount || subtotal);

    const productRows = products.map((p, i) => `
      <div class="product-row">
        <span>${p.quantity || 0}</span>
        <span>${(p.name || p.model || `Producto ${i + 1}`)}</span>
        <span>$${fmt(p.price)}</span>
        <span>$${fmt((Number(p.price) || 0) * (Number(p.quantity) || 0))}</span>
      </div>
    `).join('');

    const customerDataHtml = saleInfo?.customerData?.name ? `
      <div class="remito-customer">
        <h4>DATOS DEL CLIENTE:</h4>
        <div class="customer-row"><strong>Nombre:</strong><span>${saleInfo.customerData.name || ''}</span></div>
        ${saleInfo.customerData.cuit ? `<div class="customer-row"><strong>CUIT:</strong><span>${saleInfo.customerData.cuit}</span></div>` : ''}
        ${saleInfo.customerData.phone ? `<div class="customer-row"><strong>Teléfono:</strong><span>${saleInfo.customerData.phone}</span></div>` : ''}
        ${saleInfo.customerData.address ? `<div class="customer-row"><strong>Dirección:</strong><span>${saleInfo.customerData.address}</span></div>` : ''}
      </div>
      <div class="remito-divider"></div>
    ` : '';

    const escapedDescription = (descriptionText || '').replace(/</g, '&lt;').replace(/\n/g, '<br/>');

    const detailBlock = useDescription
      ? `
        <div class="remito-description">
          <h4>DESCRIPCIÓN:</h4>
          <div>${escapedDescription || '-'}</div>
        </div>
      `
      : `
        <div class="remito-products">
          <h4>PRODUCTOS:</h4>
          <div class="products-header">
            <span>Cant.</span><span>Producto</span><span>Precio</span><span>Total</span>
          </div>
          ${productRows}
        </div>
      `;

    const printStyles = `
      @page { size: A4 portrait; margin: 8mm; }
      * { box-sizing: border-box; }
      html, body { height: auto; }
      body { margin: 0; font-family: Arial, sans-serif; color: #333; -webkit-print-color-adjust: exact; print-color-adjust: exact; }
      .remito-content-root { background: #fff; color: #333; padding: 16px; font-size: 13px; line-height: 1.4; display: flex; flex-direction: column; }
      .remito-spacer { flex: 1 1 auto; min-height: 0; }
      .remito-header { display: flex; align-items: flex-start; gap: 12px; margin-bottom: 10px; position: relative; }
      .remito-logo { width: 260px; height: auto; }
      .remito-company { flex: 1; text-align: right; font-size: 11px; }
      .remito-company h3 { margin: 0 0 4px 0; font-size: 15px; color: #2c3e50; }
      .remito-company p { margin: 2px 0; color: #555; }
      .remito-type-box { position: absolute; left: 50%; top: 0; transform: translate(-50%, -10%); width: 42px; height: 42px; border: 1px solid #000; border-radius: 4px; display: flex; flex-direction: column; align-items: center; justify-content: center; background: #f7f7f7; font-size: 11px; font-weight: 600; }
      .remito-type-letter { font-size: 22px; line-height: 1; }
      .remito-type-label { margin-top: 2px; }
      .remito-divider { border-bottom: 1px solid #ddd; margin: 10px 0; }
      .remito-order .order-row { display: flex; justify-content: space-between; margin-bottom: 4px; }
      .remito-products h4, .remito-description h4 { margin: 0 0 8px 0; color: #2c3e50; font-size: 13px; }
      .products-header { display: grid; grid-template-columns: 1fr 3fr 1.2fr 1.2fr; gap: 8px; padding: 6px 8px; font-weight: bold; background: #f5f5f5; border-radius: 4px; margin-bottom: 4px; }
      .product-row { display: grid; grid-template-columns: 1fr 3fr 1.2fr 1.2fr; gap: 8px; padding: 6px 8px; border-bottom: 1px solid #eee; }
      .remito-summary { margin-top: 10px; }
      .summary-row { display: flex; justify-content: space-between; margin-bottom: 4px; }
      .total-row { padding-top: 8px; border-top: 2px solid #ddd; font-size: 15px; margin-top: 8px; }
      .remito-customer { margin: 10px 0; }
      .customer-row { display: flex; justify-content: space-between; align-items: center; margin: 4px 0; }
      .customer-row span { max-width: 60%; text-align: right; }
      .remito-transport { margin: 4px 0 10px 0; }
      .signature-section { text-align: center; }
      .signature-line { height: 2px; background: #ddd; margin-bottom: 8px; }
      .remito-signatures { page-break-inside: avoid; padding-top: 20px; }
      .remito-footer { text-align: center; margin-top: 10px; padding-top: 6px; border-top: 1px solid #ddd; font-size: 11px; color: #666; page-break-inside: avoid; }
      .remito-description { margin-bottom: 10px; }
      .remito-observations { margin-bottom: 10px; }
    `;

    const remitoNumber = saleInfo?.remitoNumber || 'SIN-NUMERO';

    const contentHtml = `
      <div class="remito-content-root">
        <div class="remito-header">
          <img src="${logo}" alt="Priball Logo" class="remito-logo" />
          <div class="remito-type-box">
            <span class="remito-type-letter">R</span>
            <span class="remito-type-label">Remito</span>
          </div>
          <div class="remito-company">
            <h3>REMITO DE TRANSPORTE</h3>
            <p>Fábrica de balones deportivos</p>
            <p>Ruta 9 y Junín, Bell Ville, Cba.</p>
            <p>Tel: (3537) 302888</p>
            <p>www.priball.com</p>
            <p>Monotributista · CUIT: ${CUIT_EMISOR}</p>
            <p>Ingresos Brutos: ${INGRESOS_BRUTOS}</p>
            <p>Inicio de Actividades: ${FECHA_INICIO_ACTIVIDADES}</p>
          </div>
        </div>

        <div class="remito-divider"></div>

        <div class="remito-order">
          <div class="order-row"><strong>Número de Remito:</strong><span>${remitoNumber}</span></div>
          <div class="order-row"><strong>Número de Orden:</strong><span>${saleInfo.orderNumber || 'N/A'}</span></div>
          <div class="order-row"><strong>Fecha de Emisión:</strong><span>${normalizeDate(saleInfo.date)}</span></div>
        </div>

        ${customerDataHtml}

        ${detailBlock}

        <div class="remito-divider"></div>

        <div class="remito-summary">
          <div class="summary-row total-row"><strong>VALOR DECLARADO: $${fmt(total)}</strong></div>
        </div>

        <div class="remito-divider"></div>

        <div class="remito-transport">
          <h4>INFORMACIÓN DE TRANSPORTE:</h4>
          <div class="customer-row"><strong>Transportista:</strong><span>${transportista || ''}</span></div>
        </div>

        <div class="remito-divider"></div>

        <div class="remito-observations">
          <h4>OBSERVACIONES:</h4>
          <div>${(observaciones || '').replace(/</g, '&lt;').replace(/\n/g, '<br/>')}</div>
        </div>
        <br />
        <hr />
        <div class="remito-spacer"></div>

        <div class="remito-signatures" style="display:grid;grid-template-columns:repeat(3,1fr);gap:20px;margin:0;">
          <div class="signature-section"><div class="signature-line"></div><p>Firma del Cliente</p></div>
          <div class="signature-section"><div class="signature-line"></div><p>Firma del Transportista</p></div>
          <div class="signature-section"><div class="signature-line"></div><p>Firma del Emisor</p></div>
        </div>

        <div class="remito-footer">
          <p>Este remito debe ser devuelto firmado por el cliente</p>
          <p>Priball - Calidad y tradición en balones deportivos</p>
          <p>www.priball.com</p>
        </div>
      </div>
    `;

    const iframe = document.createElement('iframe');
    iframe.style.position = 'fixed';
    iframe.style.right = '0';
    iframe.style.bottom = '0';
    iframe.style.width = '0';
    iframe.style.height = '0';
    iframe.style.border = '0';
    document.body.appendChild(iframe);

    const doc = iframe.contentWindow?.document;
    if (!doc) {
      window.print();
      return;
    }

    doc.open();
    doc.write(`<!doctype html><html><head><meta charset="utf-8" />
      <title>Remito</title>
      <style>${printStyles}</style>
    </head><body>${contentHtml}</body></html>`);
    doc.close();

    iframe.onload = () => {
      const w = iframe.contentWindow;
      if (!w) return;
      w.focus();
      w.print();
      setTimeout(() => {
        document.body.removeChild(iframe);
      }, 100);
    };
  };

  if (!saleInfo) {
    return <div className="remito-error">No hay información disponible</div>;
  }

  const remitoNumber = saleInfo?.remitoNumber || 'SIN-NUMERO';
  const products = saleInfo.products || [];

  return (
    <div className="remito-content-root">
      <div className="remito-header">
        <img src={logo} alt="Priball Logo" className="remito-logo" />
        <div className="remito-type-box">
          <span className="remito-type-letter">R</span>
          <span className="remito-type-label">Remito</span>
        </div>
        <div className="remito-company">
          <h3>REMITO DE TRANSPORTE</h3>
          <p>Fábrica de balones deportivos</p>
          <p>Ruta 9 y Junín, Bell Ville, Cba.</p>
          <p>Tel: (3537) 302888</p>
          <p>www.priball.com</p>
          <p>Monotributista · CUIT: {CUIT_EMISOR}</p>
          <p>Ingresos Brutos: {INGRESOS_BRUTOS}</p>
          <p>Inicio de Actividades: {FECHA_INICIO_ACTIVIDADES}</p>
        </div>
      </div>

      <div className="remito-divider" />

        <div className="remito-order">
        <div className="order-row"><strong>Número de Remito:</strong><span>{remitoNumber}</span></div>
        <div className="order-row"><strong>Número de Orden:</strong><span>{saleInfo.orderNumber || 'N/A'}</span></div>
        <div className="order-row"><strong>Fecha de Emisión:</strong><span>{normalizeDate(saleInfo.date)}</span></div>
      </div>

      {!!saleInfo?.customerData?.name && (
        <>
          <div className="remito-customer">
            <h4>DATOS DEL CLIENTE:</h4>
            <div className="customer-row"><strong>Nombre:</strong><span>{saleInfo.customerData.name}</span></div>
            {!!saleInfo.customerData.cuit && (
              <div className="customer-row"><strong>CUIT:</strong><span>{saleInfo.customerData.cuit}</span></div>
            )}
            {!!saleInfo.customerData.phone && (
              <div className="customer-row"><strong>Teléfono:</strong><span>{saleInfo.customerData.phone}</span></div>
            )}
            {!!saleInfo.customerData.address && (
              <div className="customer-row"><strong>Dirección:</strong><span>{saleInfo.customerData.address}</span></div>
            )}
          </div>
          <div className="remito-divider" />
        </>
      )}

      {/* Opciones para reemplazar la tabla por descripción */}
      <div className="remito-options">
        <label className="checkbox-row">
          <input type="checkbox" checked={useDescription} onChange={(e) => setUseDescription(e.target.checked)} />
          Usar descripción en lugar de tabla de productos
        </label>
        {useDescription && (
          <textarea
            className="desc-input"
            placeholder="Ingrese una descripción detallada del envío..."
            value={descriptionText}
            onChange={(e) => setDescriptionText(e.target.value)}
            rows={3}
          />
        )}
      </div>

      {!useDescription ? (
        <div className="remito-products">
          <h4>PRODUCTOS:</h4>
          <div className="products-header">
            <span>Cant.</span>
            <span>Producto</span>
            <span>Precio</span>
            <span>Total</span>
          </div>
          {products.map((p, idx) => (
            <div key={idx} className="product-row">
              <span>{p.quantity || 0}</span>
              <span>{p.name || p.model || `Producto ${idx + 1}`}</span>
              <span>${formatNumber(Number(p.price) || 0)}</span>
              <span>${formatNumber((Number(p.price) || 0) * (Number(p.quantity) || 0))}</span>
            </div>
          ))}
        </div>
      ) : (
        <div className="remito-description">
          <h4>DESCRIPCIÓN:</h4>
          <div className="desc-preview">{descriptionText || '-'}</div>
        </div>
      )}

      <div className="remito-divider" />

      <div className="remito-summary">
        <div className="summary-row total-row">
          <strong>VALOR DECLARADO: ${formatNumber(Number(saleInfo?.totalPrice) || totalWithDiscount || 0)}</strong>
        </div>
      </div>

      <div className="remito-divider" />

      <div className="remito-transport">
        <h4>INFORMACIÓN DE TRANSPORTE:</h4>
        <div className="transport-row">
          <strong>Transportista:</strong>
          <input className="screen-only-input" type="text" value={transportista} onChange={(e) => setTransportista(e.target.value)} placeholder="Nombre del transportista" />
          <span className="print-only-text">{transportista}</span>
        </div>
      </div>

      <div className="remito-divider" />

      <div className="remito-observations">
        <h4>OBSERVACIONES:</h4>
        <textarea className="screen-only-input obs-input" value={observaciones} onChange={(e) => setObservaciones(e.target.value)} placeholder="Ingrese observaciones adicionales..." rows={3} />
        <div className="print-only-text">{observaciones}</div>
      </div>

      <div className="remito-spacer" />

      <div className="remito-signatures">
        <div className="signature-section"><div className="signature-line" /><p>Firma del Cliente</p></div>
        <div className="signature-section"><div className="signature-line" /><p>Firma del Transportista</p></div>
        <div className="signature-section"><div className="signature-line" /><p>Firma del Emisor</p></div>
      </div>

      <div className="remito-footer">
        <p>Este remito debe ser devuelto firmado por el cliente</p>
        <p>Priball - Calidad y tradición en balones deportivos</p>
        <p>www.priball.com</p>
      </div>

      <div className="remito-actions">
        <button className="remito-print-btn" onClick={handlePrint}>🖨️ Imprimir Remito</button>
        {onClose && (
          <button className="remito-close-btn" onClick={onClose}>Cerrar</button>
        )}
      </div>
    </div>
  );
};

export default RemitoPrintInline;
